export const ACTIONS = {
  REQUEST_EMPLOYER_BENEFIT_INFO: 'REQUEST_EMPLOYER_BENEFIT_INFO',
  RECEIVE_EMPLOYER_BENEFIT_INFO: 'RECEIVE_EMPLOYER_BENEFIT_INFO',
  REQUEST_EMPLOYER_BENEFIT_INFO_ERROR: 'REQUEST_EMPLOYER_BENEFIT_INFO_ERROR',
};
export default ACTIONS;
